// This file was auto-generated by commondatabuilder.
// Please don't edit it.

export type LeaseChoice = "RENT_STABILIZED"|"RENT_CONTROLLED"|"OTHER_AFFORDABLE"|"MARKET_RATE"|"NYCHA"|"NOT_SURE"|"NO_LEASE"|"RENT_STABILIZED_OR_CONTROLLED";

export const LeaseChoices: LeaseChoice[] = [
  "RENT_STABILIZED",
  "RENT_CONTROLLED",
  "OTHER_AFFORDABLE",
  "MARKET_RATE",
  "NYCHA",
  "NOT_SURE",
  "NO_LEASE",
  "RENT_STABILIZED_OR_CONTROLLED"
];

const LeaseChoiceSet: Set<String> = new Set(LeaseChoices);

export function isLeaseChoice(choice: string): choice is LeaseChoice {
  return LeaseChoiceSet.has(choice);
}

export type LeaseChoiceLabels = {
  [k in LeaseChoice]: string;
};

export function getLeaseChoiceLabels(): LeaseChoiceLabels {
  return {
    RENT_STABILIZED: "Rent Stabilized",
    RENT_CONTROLLED: "Rent Controlled",
    OTHER_AFFORDABLE: "Affordable housing (other than rent-stabilized)",
    MARKET_RATE: "Market Rate",
    NYCHA: "NYCHA/Public Housing (includes RAD/PACT)",
    NOT_SURE: "I'm not sure",
    NO_LEASE: "I don't have a lease",
    RENT_STABILIZED_OR_CONTROLLED: "Either Rent Stabilized or Rent Controlled (legacy option)",
  };
}
